import { ALL_LOCATIONS, NO_ORG_LOCATION } from "~/utils/Constants";
import { Org } from "~/utils/Types";

export const getOrgShortName = (org: Org): string =>
  org?.idString ? org.idString.split("_")[0] : "NotValidOrg";

// A customer whose idString carries no location part (e.g. "MEQ", "GMP") is
// stored at the org-wide place, so that is the key its requests address.
export const getOrgLocation = (org: Org): string => {
  if (!org) {
    return NO_ORG_LOCATION;
  }

  return org.idString.split("_")[1] ?? ALL_LOCATIONS;
};

export const isAllLocations = (org: Org): boolean =>
  getOrgLocation(org) === ALL_LOCATIONS;

export const isJbsBrazil = (org: Org): boolean =>
  getOrgShortName(org).toLowerCase() === "jbsbrazil";

// The mock Demo USA portal (scenarios/DemoUSA) — org idString "Demo_USA".
export const isDemoUsa = (org: Org): boolean => org?.idString === "Demo_USA";

// True for any Harmony org (short name "Harmony"), including the
// "Harmony_OConnor" plant. Callers that need to exclude a specific plant
// (e.g. O'Connor) should additionally check getOrgLocation().
export const isHarmony = (org: Org): boolean =>
  getOrgShortName(org).toLowerCase() === "harmony";
